import React from 'react';
import { Link } from 'react-router-dom';
import { HabbitLogo } from '../HabbitLogo';
export function MarketingFooter() {
  return <footer className="bg-[#050505] border-t border-surface-200/30 pt-16 pb-8" data-id="element-175">
      <div className="max-w-6xl mx-auto px-6" data-id="element-176">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-177">
          <div className="col-span-1 md:col-span-2" data-id="element-178">
            <Link to="/" className="flex items-center gap-3 mb-4" data-id="element-179">
              <HabbitLogo size={30} data-id="element-180" />
              <span className="text-2xl font-mono font-bold tracking-tight text-gray-100" data-id="element-181">
                habbit<span className="text-centurion-500" data-id="element-182">.</span>
              </span>
            </Link>
            <p className="text-gray-400 max-w-md text-sm leading-relaxed" data-id="element-183">
              The first Agentic OS that closes the loop between your calendar
              and your biometrics. We don't just track the streak — we automate
              the execution.
            </p>
          </div>

          <div data-id="element-184">
            <h4 className="text-gray-100 font-mono font-semibold mb-4 uppercase tracking-wider text-sm" data-id="element-185">
              Navigate
            </h4>
            <ul className="space-y-3" data-id="element-186">
              <li data-id="element-187">
                <a href="#protocol" className="text-gray-400 hover:text-centurion-400 transition-colors text-sm font-mono" data-id="element-188">
                  The Protocol
                </a>
              </li>
              <li data-id="element-189">
                <a href="#peer-board" className="text-gray-400 hover:text-centurion-400 transition-colors text-sm font-mono" data-id="element-190">
                  Peer Board
                </a>
              </li>
              <li data-id="element-191">
                <a href="#privacy" className="text-gray-400 hover:text-centurion-400 transition-colors text-sm font-mono" data-id="element-192">
                  Privacy
                </a>
              </li>
              <li data-id="element-193">
                <Link to="/app" className="text-gray-400 hover:text-centurion-400 transition-colors text-sm font-mono" data-id="element-194">
                  Initialize System
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-surface-200/30 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500" data-id="element-195">
          <p className="font-mono" data-id="element-196">
            A Hectad Collective Project. US-Structured Entity. Silicon Valley
            Roots. Bengaluru Based.
          </p>
          <p data-id="element-197">
            &copy; {new Date().getFullYear()} habbit.at. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}